import { useEffect, useState } from 'react';

export const PROMOTION_VISIBILITY_REFRESH_MS = 60_000;

export function usePromotionVisibilityNowMs(): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const intervalId = window.setInterval(
      () => setNowMs(Date.now()),
      PROMOTION_VISIBILITY_REFRESH_MS,
    );

    return () => window.clearInterval(intervalId);
  }, []);

  return nowMs;
}
